/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cognito_identity_pool_id": "us-east-2:6dda2cbb-d940-4a4c-9a5d-e376aa240716",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_vwq8FVQ4p",
    "aws_user_pools_web_client_id": "7o9g5k4rhkucvsveg4i9lv009l",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL",
        "NAME",
        "PHONE_NUMBER"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://5rdf5hrcb6.execute-api.us-east-2.amazonaws.com/staging",
            "region": "us-east-2"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://tp562mq6czae7oe2wjktyyqgca.appsync-api.us-east-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-qz3gqwzztnb2bnpcbaoqfy6dqe",
    "aws_user_files_s3_bucket": "propertyimages123210-staging",
    "aws_user_files_s3_bucket_region": "us-east-2"
};


export default awsmobile;
